import { ConnectionQuality, ConnectionState } from "livekit-client";

/**
 * True while the room's own connection is actively reconnecting — callers
 * should keep the room mounted and show a "connection unstable" banner
 * rather than treating the participant as disconnected.
 */
export function isReconnectingConnectionState(state: ConnectionState): boolean {
  return (
    state === ConnectionState.Reconnecting ||
    state === ConnectionState.SignalReconnecting
  );
}

/**
 * True once a participant's signal has dropped entirely, not merely
 * degraded — the threshold livekit-client marks as "lost".
 */
export function isLostConnectionQuality(quality: ConnectionQuality): boolean {
  return quality === ConnectionQuality.Lost;
}
